import { render, staticRenderFns } from "./addSupplier.vue?vue&type=template&id=3ded236c&scoped=true&"
import script from "./addSupplier.vue?vue&type=script&lang=js&"
export * from "./addSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded236c",
  null
  
)

export default component.exports